import axiosInstance from './intercept';

/* eslint-disable import/prefer-default-export */
export function getPermissions() {
  return axiosInstance.get('/v1/portal_users/permissions');
}
